import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#services", label: "SERVICES" },
  { href: "#gallery", label: "BEFORE & AFTER" },
  { href: "#locations", label: "MUMBAI LOCATIONS" },
  { href: "#about", label: "ABOUT US" },
  { href: "#gst-info", label: "GST INFO" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/ae-logo.png" alt="Anas Enterprises AE logo" className="h-12 w-auto object-contain" />
          <span>
            <span className="display-font text-base sm:text-2xl tracking-tight text-[#0f172a] block leading-none">ANAS ENTERPRISES</span>
            <span className="text-[8px] sm:text-[10px] tracking-widest uppercase font-bold text-slate-500 block mt-0.5">Civil Interior Contractor</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8 text-sm font-semibold tracking-wide text-slate-700">
          {NAV_LINKS.map((l) => (
            <a key={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} href={l.href} className="hover:text-[#1e3a8a] transition-colors">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-direct-call-btn"
            href="tel:+919867439947"
            className="hidden sm:inline-flex items-center justify-center px-4 py-2.5 bg-slate-100 hover:bg-slate-200 text-[#0f172a] text-xs font-bold uppercase tracking-wider rounded transition-colors"
          >
            Direct Call
          </a>
          <a
            data-testid="nav-quote-btn"
            href="#contact"
            className="inline-flex items-center justify-center px-5 py-2.5 bg-[#1e3a8a] hover:bg-[#1e40af] text-white text-xs font-bold uppercase tracking-wider rounded shadow-sm transition-colors"
          >
            Get Free Quote
          </a>
          <button
            data-testid="nav-mobile-menu-btn"
            type="button"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-slate-800"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-sm font-semibold tracking-wide text-slate-700 hover:text-[#1e3a8a] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
